import { render, staticRenderFns } from "./group.vue?vue&type=template&id=6a35855b&scoped=true&"
import script from "./group.vue?vue&type=script&lang=js&"
export * from "./group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35855b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a35855b')) {
      api.createRecord('6a35855b', component.options)
    } else {
      api.reload('6a35855b', component.options)
    }
    module.hot.accept("./group.vue?vue&type=template&id=6a35855b&scoped=true&", function () {
      api.rerender('6a35855b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormCreate/File/group.vue"
export default component.exports